import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontSize: 16,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.7rem",
      fontWeight: 700,
      lineHeight: 1.1,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1.8rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "1.5rem",
      },
    },
    h2: {
      fontSize: "2.25rem",
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1.75rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "1.4rem",
      },
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1.5rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "1.25rem",
      },
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 700,
      lineHeight: 1.4,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1.25rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "1.1rem",
      },
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
      lineHeight: 1.4,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1.1rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "1rem",
      },
    },
    h6: {
      fontSize: "1.1rem",
      fontWeight: 600,
      lineHeight: 1.5,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "0.95rem",
      },
    },
    subtitle1: {
      fontSize: "1.1rem",
      fontWeight: 500,
      lineHeight: 1.5,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "0.95rem",
      },
    },
    subtitle2: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: 1.5,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "0.95rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "0.9rem",
      },
    },
    body1: {
      fontSize: "1.15rem",
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "1rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "0.95rem",
      },
    },
    body2: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "0.95rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "0.9rem",
      },
    },
    caption: {
      fontSize: "0.9rem",
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: 0,
      "@media (max-width: 768px)": {
        fontSize: "0.85rem",
      },
      "@media (max-width: 480px)": {
        fontSize: "0.8rem",
      },
    },
    button: {
      fontSize: "1rem",
      fontWeight: 600,
      lineHeight: 1.5,
      letterSpacing: 0,
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: "#3C1C34",
    },
    secondary: {
      main: "#FEB533",
    },
    background: {
      default: "#fff",
      paper: "#ffffff",
    },
    text: {
      primary: "#fff",
      secondary: "#000",
    },
    common: {
      black: "#000",
      white: "#ffffff",
    },
    warning: {
      main: "#059669",
      dark: "#047857",
      light: "#10B981",
    },
    error: {
      main: "#d62828",
    },
    info: {
      main: "#eae2b7",
    },
    success: {
      main: "#f77f00",
    },
    grey: {
      200: "#ECECEC",
      300: "#cfcfcf",
      400: "#444444",
      500: "#202020",
      600: "#DCDCDC",
    },
  },
});

export default theme;
